<template>
  <div>
    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '12px 16px 4px' }"
    >
      <div class="module-header-fs14" style="margin-bottom: 8px">工单情况</div>

      <div :size="16" class="statistic-card">
        <div class="ticket-item">
          <div>
            <div class="title">当日新建工单总数</div>
            <div class="value">
              {{
                isNotUndefined(statisticsDetail?.work_order_created_today)
                  ? statisticsDetail.work_order_created_today
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="ticket-item">
          <div>
            <div class="title">当日已关闭工单</div>
            <div class="value">
              {{
                isNotUndefined(statisticsDetail?.work_order_closed_today)
                  ? statisticsDetail.work_order_closed_today
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="ticket-item">
          <div>
            <div class="title">工单总数</div>
            <div class="value">
              {{
                isNotUndefined(statisticsDetail?.work_order_total)
                  ? statisticsDetail.work_order_total
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="ticket-item">
          <div>
            <div class="title">工单超时响应数</div>
            <div class="value">
              {{
                isNotUndefined(statisticsDetail?.work_order_total)
                  ? statisticsDetail.work_order_total
                  : '-'
              }}
            </div>
          </div>
        </div>

        <div class="ticket-item">
          <div>
            <div class="title">工单闭环率</div>
            <div class="value">
              {{
                isNotUndefined(statisticsDetail?.work_order_closed_rate)
                  ? statisticsDetail.work_order_closed_rate
                  : '-'
              }}%
            </div>
          </div>
        </div>
      </div>

      <!-- chart -->
      <div v-if="visible">
        <div class="module-header-fs14" style="margin: 24px 0 8px 0">
          工单趋势统计
        </div>
        <div v-if="chartData" style="padding: 10px">
          <line-chart
            chartId="ticket-count-trend-chart"
            colorType="type"
            :chartData="chartData"
            :height="268"
            :showArea="false"
            :legendOptions="{
              position: 'top',
              offsetY: -8
            }"
            :is-smooth="false"
          ></line-chart>
        </div>
      </div>

      <!-- 按钮 -->
      <div style="text-align: center">
        <a-button type="link" @click="changeDisplay">
          <a-icon v-if="!visible" type="caret-down" />
          <a-icon v-else type="caret-up" />
          <span>{{ visible ? '收起' : '展开' }}</span>
        </a-button>
      </div>
    </a-card>

    <a-card
      :bordered="false"
      style="margin-bottom: 16px"
      :body-style="{ padding: '16px' }"
    >
      <div class="table-operation-container">
        <a-space style="float: left">
          <datetime-range
            class="table-range"
            @ok="
              v => {
                datetimeRange = v
                fetch()
              }
            "
          ></datetime-range>
        </a-space>

        <a-space size="middle" style="float: right">
          <!-- 刷新 -->
          <reload-button @click="() => fetchTableData()"></reload-button>

          <!-- 导出 -->
          <export-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            :export-func="exportFunc"
            :params="fetchParams"
            title="信息中心工单闭环情况"
          ></export-button>

          <!-- 设置 -->
          <setting-button
            :columns="columnsAll"
            :default-selected="columnDefaultSelected"
            @selected="v => (columns = v)"
          ></setting-button>
        </a-space>
      </div>

      <a-table
        rowKey="process_id"
        ref="table"
        class="custom-table scroll-hidden-table"
        :data-source="tableData"
        @change="handleTableChange"
        :columns="columns"
        :loading="loading"
        :scroll="{ x: scrollX }"
        :pagination="{
          total: total,
          defaultPageSize: 10,
          showTotal: v => `共 ${v} 条`
        }"
      >
        <span slot="process_name" slot-scope="text">
          <a-tooltip placement="topLeft" :title="text">
            {{ text || '-' }}
          </a-tooltip>
        </span>

        <span slot="today_average_close_time" slot-scope="text">
          {{ text }}分
        </span>

        <span slot="history_average_close_time" slot-scope="text">
          {{ text }}分
        </span>

        <span slot="today_closed_rate" slot-scope="text"> {{ text }}% </span>

        <span slot="history_closed_rate" slot-scope="text"> {{ text }}% </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {
  getSystemStatistics,
  getTicketTrend,
  getTicketList,
  exportTable
} from '@/api/boss'
import DatetimeRange from '@/components/DatetimeRange'
import LineChart from '@/components/chart/LineChart.vue'
import ExportButton from '@/components/button/ExportButton'
import ReloadButton from '@/components/button/ReloadButton'
import SettingButton from '@/components/button/SettingButton'
import { isNotUndefined } from '@/utils'

export default {
  name: 'TicketClosedLoop',
  components: {
    DatetimeRange,
    LineChart,
    ExportButton,
    ReloadButton,
    SettingButton
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        if (column?.children) {
          column.children.forEach(child => {
            sum += child.width
          })
        } else {
          sum += column.width
        }
      })
      return sum
    }
  },
  data () {
    return {
      isNotUndefined,
      fetchParams: {},
      loading: false, // 表格加载状态
      tableData: [], // 表格数据
      total: 0, // 表格数据总数
      exportFunc: exportTable,
      columnsAll: [
        {
          dataIndex: 'process_name',
          title: '工单分类',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'process_name'
          }
        },
        {
          title: '当日工单情况',
          children: [
            {
              dataIndex: 'today_created_today',
              title: '新建工单数',
              width: 140,
              scopedSlots: {
                customRender: 'today_created_today'
              },
              sorter: true
            },
            {
              dataIndex: 'today_closed_today',
              title: '已关闭工单数',
              width: 140,
              scopedSlots: {
                customRender: 'today_closed_today'
              },
              sorter: true
            },
            {
              dataIndex: 'today_average_close_time',
              title: '平均关闭时效',
              width: 140,
              scopedSlots: {
                customRender: 'today_average_close_time'
              },
              sorter: true
            },
            {
              dataIndex: 'today_close_timeout',
              title: '超时响应数',
              width: 140,
              scopedSlots: {
                customRender: 'today_close_timeout'
              },
              sorter: true
            },
            {
              dataIndex: 'today_closed_rate',
              title: '工单闭环率',
              width: 140,
              scopedSlots: {
                customRender: 'today_closed_rate'
              },
              sorter: true
            }
          ]
        },
        {
          title: '历史工单情况',
          children: [
            {
              dataIndex: 'history_total',
              title: '历史工单总数',
              width: 140,
              scopedSlots: {
                customRender: 'history_total'
              },
              sorter: true
            },
            {
              dataIndex: 'history_closed',
              title: '历史已关闭',
              width: 140,
              scopedSlots: {
                customRender: 'history_closed'
              },
              sorter: true
            },
            {
              dataIndex: 'history_average_close_time',
              title: '历史平均关闭时效',
              width: 164,
              scopedSlots: {
                customRender: 'history_average_close_time'
              },
              sorter: true
            },
            {
              dataIndex: 'history_timeout',
              title: '历史响应超时数',
              width: 152,
              scopedSlots: {
                customRender: 'history_timeout'
              },
              sorter: true
            },
            {
              dataIndex: 'history_closed_rate',
              title: '历史闭环率',
              width: 140,
              scopedSlots: {
                customRender: 'history_closed_rate'
              },
              sorter: true
            }
          ]
        }
      ],
      columnDefaultSelected: [
        'process_name',
        'today_created_today',
        'today_closed_today',
        'today_closed_rate',
        'history_total',
        'history_closed_rate',
        'history_timeout',
        'history_closed_rate'
      ],
      columns: [],
      visible: false, // 更多统计展示
      datetimeRange: [],
      chartData: [], // 工单数量趋势图
      statisticsDetail: {} // 统计头数据
    }
  },
  mounted () {
    this.columns = []
    this.columnsAll.forEach(column => {
      if (column?.children) {
        const obj = {
          title: column.title,
          children: []
        }
        column.children.forEach(child => {
          if (this.columnDefaultSelected.indexOf(child.dataIndex) !== -1) {
            obj.children.push(child)
          }
        })
        this.columns.push(obj)
      } else {
        if (this.columnDefaultSelected.indexOf(column.dataIndex) !== -1) {
          this.columns.push(column)
        }
      }
    })
    this.fetch()
  },
  methods: {
    changeDisplay () {
      this.visible = !this.visible
    },
    fetch () {
      this.fetchStatistics()
      this.fetchChartData()
      this.fetchTableData()
    },
    fetchStatistics () {
      const params = {}
      if (this.datetimeRange.length) {
        params.start = this.datetimeRange[0].format(
          'YYYY-MM-DD HH:mm:ss'
        )
        params.end = this.datetimeRange[1].format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      getSystemStatistics(params).then(res => {
        this.statisticsDetail = res.data
      })
    },
    fetchChartData () {
      const params = {}
      if (this.datetimeRange.length) {
        params.start = this.datetimeRange[0].format(
          'YYYY-MM-DD HH:mm:ss'
        )
        params.end = this.datetimeRange[1].format(
          'YYYY-MM-DD HH:mm:ss'
        )
      }
      getTicketTrend(params).then(res => {
        if (res.data?.result) {
          this.chartData = res.data.result.map(item => {
            return {
              type: item.process_name,
              value: item.count,
              date: item.time_period
            }
          })
        } else this.chartData = []
      })
    },
    fetchTableData () {
      this.loading = true
      if (this.datetimeRange.length) {
        this.fetchParams.start = this.datetimeRange[0].format(
          'YYYY-MM-DD HH:mm:ss'
        )
        this.fetchParams.end = this.datetimeRange[1].format(
          'YYYY-MM-DD HH:mm:ss'
        )
      } else {
        delete this.fetchParams.start
        delete this.fetchParams.end
      }
      getTicketList(this.fetchParams)
        .then(res => {
          this.tableData = res.data?.data || []
          this.total = res.data?.total || 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleTableChange (pagination, filters, sorter) {
      const { order, field } = sorter

      if (order) {
        this.fetchParams.sort_by = field
        this.fetchParams.order_by = order
        if (order === 'ascend') this.fetchParams.order_by = 'asc'
        else if (order === 'descend') this.fetchParams.order_by = 'desc'
      } else {
        delete this.fetchParams.sort_by
        delete this.fetchParams.order_by
      }
      this.fetchTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.statistic-card {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(188px, 1fr));
  gap: 16px;

  .ticket-item {
    color: #408bf3;
    width: 100%;
    height: 84px;
    border-radius: 6px;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url('../../assets/images/service-monitor/statistic-ticket.png');

    & > div {
      text-align: center;
      padding: 12px 0 0 6px;
      margin-right: 48px;
      overflow: hidden;

      .title {
        font-size: 12px;
      }

      .value {
        font-size: 30px;
        font-weight: 500;
      }
    }
  }
}

.top-container {
  margin-top: 22px;
}

.table-operation-container {
  height: 34px;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 34px;
  overflow: hidden;

  .table-range {
    height: 32px;
    & > :deep(.ant-calendar-picker-input) {
      height: 32px !important;
      .ant-calendar-range-picker-separator {
        vertical-align: baseline !important;
      }
    }
  }
}
</style>
